import { Flex, type FlexProps } from '@/ui';
import type { OrgInvite } from '../hooks/useOrganizationInvites';
import { PendingInviteRow } from './PendingInviteRow';

type Props = FlexProps & {
  invites: OrgInvite[];
  isRevoking?: boolean;
  isResending?: boolean;
  /** FAMILY orgs: show SMS contact details */
  smsContactsEnabled?: boolean;
  onRevoke: (inviteId: string, options?: { onSuccess?: () => void }) => void;
  onResend: (inviteId: string) => void;
};

export const PendingInvitesList = ({
  invites,
  isRevoking,
  isResending,
  smsContactsEnabled,
  onRevoke,
  onResend,
  ...props
}: Props) => {
  return (
    <Flex direction="column" gap="3" {...props}>
      {invites.map((invite) => (
        <PendingInviteRow
          data-testid="org-invite-row"
          invite={invite}
          isResending={isResending}
          isRevoking={isRevoking}
          key={invite.id}
          smsContactsEnabled={smsContactsEnabled}
          onResend={onResend}
          onRevoke={onRevoke}
        />
      ))}
    </Flex>
  );
};
